<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    :label="$t('code')"
                    :value="form.code"
                    outlined
                    dense
                    disabled
                    hide-details="auto"
                    background-color="disabled"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <DatePicker
                    :label="$t('date')"
                    v-model="form.date"
                    :rules="[isRequired]"
                    outlined
                    hide-details="auto"
                    dense
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-autocomplete 
                    :label="$t('target_warehouse')"
                    v-model="form.target_warehouse_id"
                    :items="warehouses"
                    item-text="display_name"
                    item-value="id"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                    @update:search-input="searchWarehouses"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <TransferIssueVoucherFormLine
                    v-for="(line, index) in form.lines"
                    :key="line.key"
                    @deleteLine="handleDeleteLine(index)"
                    v-model="form.lines[index]"
                    :items="items"
                    :itemsLoading="itemsLoading"
                    @update:items-search-input="searchItems"
                    :warehouseId="warehouseId"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <v-btn block depressed small @click="addLine">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    {{$t('add_line')}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-textarea
                    :label="$t('remarks')"
                    v-model="form.notes"
                    outlined
                    dense
                    hide-details="auto">
                </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from "./../../../utils/validations"
import TransferIssueVoucherFormLine from './TransferIssueVoucherFormLine.vue'
import DatePicker from './../../../components/common/DatePicker.vue';
import { v4 as uuid } from 'uuid';
import warehouseAPI from './../../../services/stock/warehouse';
import itemAPI from './../../../services/stockJournal/Item';

import moment from 'moment';

export default {
    components: {
        DatePicker,
        TransferIssueVoucherFormLine,
    },
    props: {
        value: Object,
        warehouseId: Number
    },
    data() {
        return {
            form: {
                code: "--",
                date: moment().format("YYYY-MM-DD"),
                source_warehouse_id: null,
                target_warehouse_id: null,
                lines: [],
                notes: null
            },
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null,
                price: 0,
                key: null
            },
            warehouses: [],
            warehousesLoading: false,
            items: [],
            itemsLoading: false
        }
    },
    watch: {
        form: {
            handler(form) {
                this.$emit("input", {...form, lines: [...form.lines]});
            },
            deep: true
        }
    },
    methods: {
        isRequired,
        addLine() {
            this.form.lines.push({...this.line, key: uuid()})
        },
        handleDeleteLine(index){
            this.form.lines.splice(index, 1)
        },
        validate() {
            return this.$refs.form.validate();
        },
        searchWarehouses(query) {
            this.warehousesLoading = true;
            warehouseAPI.searchWarehouse(query).then(response => {
                this.warehouses = Array.from(new Set([...this.warehouses, ...response.data]));
            }).finally(() => {
                this.warehousesLoading = false;
            })
        },
        searchItems(query) {
            this.itemsLoading = true;
            itemAPI.search(query).then(response => {
                this.items = Array.from(new Set([...this.items, ...response.data]));
            }).finally(() => {
                this.itemsLoading = false;
            })
        }
    },
    created() {
        if(this.value) {
            this.form = {...this.form, ...this.value};

            if(this.form.source_warehouse) {
                this.warehouses = [...this.warehouses, this.form.source_warehouse];
            }

            if(this.form.target_warehouse) {
                this.warehouses = [...this.warehouses, this.form.target_warehouse];
            }

            if(Array.isArray(this.value.lines)) {
                this.form.lines = [...this.value.lines]

                this.form.lines.forEach(each => {
                    this.items = Array.from(new Set([...this.items, each.item]))
                })
            }
            
        }
    },
    mounted() {
        if(this.form.lines.length == 0) {
            this.addLine();
        }
    }
}
</script>

<style>

</style>